import { render, staticRenderFns } from "./gj-dropdown-button.vue?vue&type=template&id=7a2e7aa0&scoped=true&"
import script from "./gj-dropdown-button.vue?vue&type=script&lang=js&"
export * from "./gj-dropdown-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2e7aa0",
  null
  
)

export default component.exports